import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "../../contexts/ApiContext";
import "../../styles/crud.css";
import "./PlayersPage.css";

function RecordModal({ player, onClose }) {
  const { matchResultsApi } = useApi();
  const {
    data: records = [],
    isLoading: loading,
    isError,
  } = useQuery({
    queryKey: ["matchResults", "byPlayer", player.name],
    queryFn: () => matchResultsApi.getByPlayer(player.name),
  });
  const error = isError ? "Could not load record." : "";

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{player.name}'s Record</h2>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        {loading ? (
          <p className="crud-loading">Loading...</p>
        ) : error ? (
          <p className="tn-err">{error}</p>
        ) : records.length === 0 ? (
          <p className="crud-empty">No match history yet.</p>
        ) : (
          <div className="crud-table-wrap">
            <table className="crud-table">
              <thead>
                <tr>
                  <th>Player</th>
                  <th>Tournament</th>
                </tr>
              </thead>
              <tbody>
                {records.map((r, i) => (
                  <tr
                    key={i}
                    className={r.result === "WIN" ? "record-win" : "record-loss"}
                  >
                    <td>
                      {r.opponent}
                      <span
                        className={`record-badge ${r.result === "WIN" ? "badge-win" : "badge-loss"}`}
                      >
                        {r.result}
                      </span>
                    </td>
                    <td>{r.tournamentName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default RecordModal;
